import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import { LargeButton, ButtonType } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import IconComponent from '../../../portal/iconComponent';
import GeneratePasswordComponent from '../../../common/generatePasswordComponent';
import PortalTextBox from '../../../portal/portalTextBox';
import RestrictionsTooltip from '../../../portal/controls/restrictionsTooltip/restrictionsTooltip';
import ValidationTopErrorMessage from '../../../portal/controls/validationTopErrorMessage';
import styles from './style.scss';

@inject('translationsStore', 'changePasswordStore', 'authStore', 'passwordPoliciesStore', 'oidcStore') @observer
export default class ChangePasswordForm extends Component {

    constructor(props) {

        super(props);
        this.state = {
            generatedPassword: ''
        };
    };

    setGeneratedPassword = (password) => {
        this.setState({ generatedPassword: password });
        this.props.changePasswordStore.newPassword = password;
    };

    componentDidMount() {
        var tenant = null;
        if (this.props.oidcStore.currentUser != null) {
            tenant = this.props.oidcStore.currentUser.profile.tenant_name;
        }
        else {
            tenant = this.props.changePasswordStore.tenant;
        }

        this.props.passwordPoliciesStore.updatePasswordPolicies(tenant);
        this.props.changePasswordStore.setPasswordChangedSuccessfully(false);
    }

    t = this.props.translationsStore.translate;

    handleOldPasswordChange = e => {
        this.props.changePasswordStore.setOldPassword(e.target.value);
        this.props.changePasswordStore.validateOldPassword();
    };

    handleNewPasswordChange = e => {
        this.props.changePasswordStore.setNewPassword(e.target.value);
        this.props.changePasswordStore.validatePassword();
    };

    handleChangePassword = () => {
        this.props.changePasswordStore.setPasswordChangedSuccessfully(true);

        if (typeof this.props.onChange === 'function') {
            this.props.onChange();
        }

        // Use setTimeout to delay the signout after password change
        setTimeout(() => {
            this.props.oidcStore.logout();
        }, 2000);

    };

    handleSubmitForm = (e) => {

        e.preventDefault();

        this.props.changePasswordStore.isError = false;
        this.props.changePasswordStore.errorMessage = '';

        const isValid = this.props.changePasswordStore.validateForm();

        if (isValid === false) {

            return;
        }

        if (this.props.isMyProfileMode === true) {

            this.props.changePasswordStore.changeMyPassword().then(() => {
                this.handleChangePassword();
            });
        } else {

            this.props.changePasswordStore.changePassword().then(() => {
                this.handleChangePassword();
            });
        }
    };

    componentWillUnmount() {

        this.props.changePasswordStore.resetForm();
        this.props.changePasswordStore.resetValidations();
    }

    render() {

        //TODO: Remove this code
        //  redirectAfterChange is always undefined
        //  if you remove the redirectAfterChange validation:
        //      it just redirects to profile page(token is invalidated but invisible to user)
        if (this.props.redirectAfterChange === true &&
            this.props.changePasswordStore.passwordChangedSuccessfully === true) {

            return <Redirect to="/" />;
        }

        return (
            <div className="change-password-form" style={{ textAlign: 'left' }}>
                <div>
                    <div className='change-password-sub-title'>
                        {this.t('CHANGE_PASSWORD_SUB_TITLE')}
                    </div>

                    <div className={classNames(styles.changePasswordErrorMessageWrapper)}>
                        <ValidationTopErrorMessage errorMessage={this.props.changePasswordStore.errorMessage} />
                    </div>

                    <div className={'form-notification-message-wrapper '
                        + (this.props.changePasswordStore.passwordChangedSuccessfully === true ? 'show' : '')}>
                        <span className="sucess-message">
                            <IconComponent iconClassName="alert-success-icon" /> {this.t('CHANGE_PASSWORD_SUCCEED')}
                        </span>
                    </div>

                    <div className={classNames(styles.titleWrapper)}>
                        <span>
                            {this.props.header}
                        </span>
                    </div>

                    <form onSubmit={this.handleSubmitForm} style={{ textAlign: 'left' }}>
                        <div style={{ width: 335, height: '500px' }}>
                            <div>
                                <PortalTextBox
                                    hintText={this.props.oldPasswordText}
                                    floatingLabelText={this.props.oldPasswordText}
                                    onChange={this.handleOldPasswordChange}

                                    errorText={this.props.changePasswordStore.oldPasswordValidationMessage}
                                    disabled={this.props.changePasswordStore.changingPassword}
                                    type="password"
                                    value={this.props.changePasswordStore.oldPassword}
                                />
                            </div>

                            <div>
                                <PortalTextBox
                                    hintText={this.t('NEW_PASSWORD')}
                                    floatingLabelText={this.t('NEW_PASSWORD')}
                                    onChange={this.handleNewPasswordChange}
                                    disabled={this.props.changePasswordStore.changingPassword}
                                    type="password"
                                    value={this.props.changePasswordStore.newPassword}
                                    underlineColor={this.props.changePasswordStore.newPassword && (this.props.changePasswordStore.newPasswordValidationMessage || []).length && '#F1605D'}
                                    underlineFocusColor={this.props.changePasswordStore.newPassword && (this.props.changePasswordStore.newPasswordValidationMessage || []).length && '#F1605D'}
                                    includeContentVisibilityToggle={true}
                                    triggerHelpTooltipOnFocus={true}
                                    helpTooltipPlacement="right"
                                    helpTooltipText={
                                        <RestrictionsTooltip isInputPristine={Boolean(this.props.changePasswordStore.newPassword)}
                                            restrictions={this.props.passwordPoliciesStore.PasswordRestrictions}
                                            failingRestrictions={this.props.changePasswordStore.newPasswordValidationMessage || []} />
                                    }
                                />
                            </div>

                            <GeneratePasswordComponent setGeneratedPassword={this.setGeneratedPassword} />

                            <div className="change-password-button">
                                <LargeButton

                                    type="submit"
                                    id="btnUpdatePasswordSubmit"
                                    dataCy="update-password-button"
                                    inProgress={this.props.changePasswordStore.changingMyPasswordProgress}
                                    text={this.t('SAVE')}
                                    style={{ marginTop: '30px' }}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    };
}